"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _Assignment = _interopRequireDefault(require("../Assignment"));
var _DisplayMessage = _interopRequireDefault(require("../DisplayMessage"));
var _CompletionButton = _interopRequireDefault(require("../WithPasscode/CompletionButton"));
var _helpers = require("../WithPasscode/helpers.js");
var _PlayerLayout = _interopRequireDefault(require("../PlayerLayout"));
var _navigations = _interopRequireDefault(require("../navigations"));
var _getFlowProgress = _interopRequireDefault(require("../DeploymentEvaluator/getFlowProgress.js"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var DeploymentPlayer = /*#__PURE__*/function (_React$Component) {
  _inherits(DeploymentPlayer, _React$Component);
  var _super = _createSuper(DeploymentPlayer);
  function DeploymentPlayer(props) {
    var _this;
    _classCallCheck(this, DeploymentPlayer);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "time", null);
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.unassignTimer();
    });
    _defineProperty(_assertThisInitialized(_this), "assignTimer", function () {
      if (_this.state.settings.autoLogout && !_this.time && !_this.state.showLogoutMsg) {
        document.addEventListener('click', _this.resetTimer, true);
        document.addEventListener('keydown', _this.resetTimer, true);
        document.addEventListener('mousemove', _this.resetTimer, true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "unassignTimer", function () {
      document.removeEventListener('click', _this.resetTimer, true);
      document.removeEventListener('keydown', _this.resetTimer, true);
      document.removeEventListener('mousemove', _this.resetTimer, true);
    });
    _defineProperty(_assertThisInitialized(_this), "getDeploymentData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _data$assignmentProgr, _data$assignmentProgr2, _data$assignmentProgr3;
      var _this$props, deploymentId, deploymentHandle, allowRetake, language, pawnId, pawnHash, surveylist, result, data, deployment;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, deploymentId = _this$props.deploymentId, deploymentHandle = _this$props.deploymentHandle, allowRetake = _this$props.allowRetake, language = _this$props.language, pawnId = _this$props.pawnId, pawnHash = _this$props.pawnHash, surveylist = _this$props.surveylist;
              if (!(!deploymentId && !deploymentHandle)) {
                _context.next = 5;
                break;
              }
              console.error('Missing both deploymentId and deploymentHandle.');
              _this.setState({
                isLoading: false,
                show404: true
              });
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.player.assignment'), _objectSpread(_objectSpread(_objectSpread({}, deploymentId ? {
                deploymentId: deploymentId
              } : {}), deploymentHandle ? {
                deploymentHandle: deploymentHandle
              } : {}), {}, {
                language: language,
                pawnId: pawnId,
                pawnHash: pawnHash,
                surveylist: surveylist
              }));
            case 7:
              result = _context.sent;
              data = result.data.data;
              if (!(!data || !data.deployment)) {
                _context.next = 12;
                break;
              }
              _this.setState({
                isLoading: false,
                show404: true
              });
              return _context.abrupt("return");
            case 12:
              if (data.pawn) {
                _context.next = 15;
                break;
              }
              _this.setState({
                isLoading: false,
                show404: true,
                type: data.deployment.type
              });
              return _context.abrupt("return");
            case 15:
              deployment = data.deployment;
              if (typeof allowRetake === 'boolean') {
                deployment.settings.allowRetake = allowRetake;
              }
              _this.setState({
                allSurveyProgress: data.surveyProgress,
                assignmentData: _objectSpread(_objectSpread({}, deployment.assignment.settings), {}, {
                  assignmentId: deployment.assignment.id,
                  handle: deployment.assignment.handle,
                  label: deployment.assignment.label,
                  surveylists: data.surveylist
                }),
                deploymentId: deployment.id,
                type: deployment.type,
                parentDeploymentId: deployment.parent_deployment_id,
                relatedDeploymentId: deployment.related_deployment_id,
                settings: deployment.settings,
                showReviewButtonOnCompletion: (!deployment.settings.postCompletionAction || deployment.settings.postCompletionAction === 'message') && !deployment.settings.logoutOnCompletion && deployment.settings.showReviewButtonOnCompletion,
                flowProgress: (0, _getFlowProgress["default"])(data),
                language: (_data$assignmentProgr = data.assignmentProgress) === null || _data$assignmentProgr === void 0 ? void 0 : _data$assignmentProgr.language,
                flowList: (_data$assignmentProgr2 = data.assignmentProgress) === null || _data$assignmentProgr2 === void 0 ? void 0 : (_data$assignmentProgr3 = _data$assignmentProgr2.surveylist) === null || _data$assignmentProgr3 === void 0 ? void 0 : _data$assignmentProgr3.handle,
                isLoading: false,
                pawn: data.pawn
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "getSelectedCondition", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(language, flowList, pawnId) {
        var _this$state, deploymentId, settings, response, conditionKey, dcwRedirectHash, bcConfig, allBranches, allConditions, selectedCondition;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state = _this.state, deploymentId = _this$state.deploymentId, settings = _this$state.settings;
                response = null;
                _context2.prev = 2;
                _context2.next = 5;
                return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.branchedCompletionAction'), {
                  deploymentId: deploymentId,
                  flowlist: flowList,
                  language: language,
                  pawnId: pawnId
                });
              case 5:
                response = _context2.sent;
                _context2.next = 13;
                break;
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                console.error(_context2.t0);
                _this.setState({
                  show404: true
                });
                return _context2.abrupt("return", null);
              case 13:
                if (!(response.data.status !== 'success')) {
                  _context2.next = 17;
                  break;
                }
                console.error('Response failed: ' + response.data.status);
                _this.setState({
                  show404: true
                });
                return _context2.abrupt("return", null);
              case 17:
                conditionKey = (0, _get2["default"])(response, 'data.data.conditionKey', 0);
                dcwRedirectHash = (0, _get2["default"])(response, 'data.data.dcwRedirectHash', '');
                bcConfig = settings.branchedCompletionConfig;
                allBranches = [].concat(_toConsumableArray(bcConfig.branches || []), [bcConfig.defaultBranch]);
                allConditions = allBranches.reduce(function (acc, b) {
                  return [].concat(_toConsumableArray(acc), _toConsumableArray(b.conditions));
                }, []);
                selectedCondition = allConditions.find(function (c) {
                  return Number(c.key) === Number(conditionKey);
                }) || {};
                selectedCondition.dcwRedirectHash = dcwRedirectHash;
                return _context2.abrupt("return", selectedCondition);
              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 8]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "logoutOnCompletion", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(settings) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!settings.logoutOnCompletion) {
                  _context3.next = 3;
                  break;
                }
                _context3.next = 3;
                return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.logout'));
              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onAlreadyComplete", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(language, flowList, pawnId) {
        var settings, selectedCondition;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                settings = _this.state.settings;
                if (!settings.allowRetake) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return");
              case 3:
                _this.setState({
                  showCompletedMsg: true
                });
                if (!(settings.postCompletionAction === 'branch')) {
                  _context4.next = 10;
                  break;
                }
                _context4.next = 7;
                return _this.getSelectedCondition(language, flowList, pawnId);
              case 7:
                selectedCondition = _context4.sent;
                if (!(selectedCondition !== null && selectedCondition.action === 'dcwRedirect' && selectedCondition.dcwRedirectHash)) {
                  _context4.next = 10;
                  break;
                }
                return _context4.abrupt("return", window.location.replace(Boilerplate.url("/d/".concat(selectedCondition.dcwRedirectHash))));
              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "setLocalOnComplete", function () {
      var _assignmentData$navig;
      var _this$state2 = _this.state,
        assignmentData = _this$state2.assignmentData,
        settings = _this$state2.settings;

      // Modules player has the option to show completion message or just kick user back to dashboard
      var isSuppressBecauseModulePlayer = ((assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.navigation) || '').startsWith('module') && (assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$navig = assignmentData.navigationSettings) === null || _assignmentData$navig === void 0 ? void 0 : _assignmentData$navig.suppressOnComplete) === true;

      // Course Wrapper should let users see certificate instead of showing completion message
      var isSuppressBecauseCourseWrapper = ((assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.navigation) || '').startsWith('courseWrapper');
      var localOnComplete = function localOnComplete() {};
      if (settings.postCompletionAction === 'branch') {
        // Call back-end for next action
        localOnComplete = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(language, flowList, pawnId) {
            var selectedCondition;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this.getSelectedCondition(language, flowList, pawnId);
                  case 2:
                    selectedCondition = _context5.sent;
                    if (selectedCondition === null) {
                      _this.setState({
                        show404: true
                      });
                    }
                    _context5.next = 6;
                    return _this.logoutOnCompletion(selectedCondition);
                  case 6:
                    _context5.t0 = selectedCondition.action;
                    _context5.next = _context5.t0 === 'url' ? 9 : _context5.t0 === 'dcwRedirect' ? 10 : _context5.t0 === 'message' ? 13 : 15;
                    break;
                  case 9:
                    return _context5.abrupt("return", window.location.replace(selectedCondition.completionUrl));
                  case 10:
                    if (!selectedCondition.dcwRedirectHash) {
                      _context5.next = 12;
                      break;
                    }
                    return _context5.abrupt("return", window.location.replace(Boilerplate.url("/d/".concat(selectedCondition.dcwRedirectHash))));
                  case 12:
                    return _context5.abrupt("break", 16);
                  case 13:
                    _this.setState({
                      completionMessage: selectedCondition.completionMessage,
                      showReviewButtonOnCompletion: !selectedCondition.logoutOnCompletion && selectedCondition.showReviewButtonOnCompletion
                    });
                    return _context5.abrupt("break", 16);
                  case 15:
                    return _context5.abrupt("break", 16);
                  case 16:
                    // Normal behavior for 'message' and fall-back behavior for
                    // 'dcwRedirect' and action not found
                    _this.setState({
                      showCompletionMsg: true
                    });
                  case 17:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));
          return function localOnComplete(_x8, _x9, _x10) {
            return _ref5.apply(this, arguments);
          };
        }();
      } else if ((settings.sendToUrl || settings.postCompletionAction === 'url') && settings.completionUrl) {
        localOnComplete = /*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this.logoutOnCompletion(settings);
                  case 2:
                    window.location.replace(settings.completionUrl);
                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));
          return function localOnComplete() {
            return _ref6.apply(this, arguments);
          };
        }();
      } else if (settings.completionMessage && !isSuppressBecauseModulePlayer && !isSuppressBecauseCourseWrapper) {
        localOnComplete = /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _this.logoutOnCompletion(settings);
                  case 2:
                    _this.setState({
                      showCompletionMsg: true
                    });
                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));
          return function localOnComplete() {
            return _ref7.apply(this, arguments);
          };
        }();
      }
      return localOnComplete;
    });
    _defineProperty(_assertThisInitialized(_this), "getPlayerLayout", function (children) {
      var assignmentData = _this.state.assignmentData;
      return /*#__PURE__*/_react["default"].createElement(_PlayerLayout["default"], {
        frameHandle: assignmentData.frameStyleId,
        showHeader: assignmentData.showHeader,
        showFooter: assignmentData.showFooter,
        settings: assignmentData.frameStyleSettings || {},
        navigation: assignmentData.navigation
      }, children);
    });
    _defineProperty(_assertThisInitialized(_this), "autoLogout", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _this$state$settings, individualPasscode, respondentConfig, usingPasscode, pathname, urlAfterLogout;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this$state$settings = _this.state.settings, individualPasscode = _this$state$settings.individualPasscode, respondentConfig = _this$state$settings.respondentConfig;
              usingPasscode = respondentConfig === 'manual' && individualPasscode;
              _context8.next = 4;
              return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.logout'));
            case 4:
              if (!_this.props.onLogout) {
                _context8.next = 7;
                break;
              }
              _context8.next = 7;
              return _this.props.onLogout();
            case 7:
              if (usingPasscode) {
                pathname = window.location.pathname;
                urlAfterLogout = (0, _helpers.passcodeLandingPage)(pathname);
                window.location.replace(Boilerplate.url(urlAfterLogout));
              }
              _this.setState({
                showLogoutMsg: true
              });
              _this.unassignTimer();
            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })));
    _defineProperty(_assertThisInitialized(_this), "resetTimer", (0, _throttle2["default"])(function () {
      var _this$state$settings2 = _this.state.settings,
        autoLogout = _this$state$settings2.autoLogout,
        autoLogoutTime = _this$state$settings2.autoLogoutTime;
      var customLength = +autoLogoutTime !== 20;
      var inMilliseconds = +autoLogoutTime * 60 * 1000;
      clearTimeout(_this.time);
      _this.time = setTimeout(_this.autoLogout, autoLogout && customLength ? inMilliseconds : 20 * 60 * 1000);
    }, 500));
    _this.state = _objectSpread(_objectSpread({
      deploymentId: props.deploymentId,
      parentDeploymentId: undefined,
      settings: {},
      assignmentData: {},
      show404: false,
      showCompletionMsg: false,
      showLogoutMsg: false
    }, props.preloadedState), {}, {
      isLoading: !props.preloadedState
    });
    return _this;
  }
  _createClass(DeploymentPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.preloadedState) {
        this.getDeploymentData();
      }
      this.assignTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.assignTimer();
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this$state$pawn, _this$state$pawn2;
      var _this$state3 = this.state,
        allSurveyProgress = _this$state3.allSurveyProgress,
        assignmentData = _this$state3.assignmentData,
        completionMessage = _this$state3.completionMessage,
        deploymentId = _this$state3.deploymentId,
        isLoading = _this$state3.isLoading,
        parentDeploymentId = _this$state3.parentDeploymentId,
        relatedDeploymentId = _this$state3.relatedDeploymentId,
        settings = _this$state3.settings,
        show404 = _this$state3.show404,
        showCompletedMsg = _this$state3.showCompletedMsg,
        showCompletionMsg = _this$state3.showCompletionMsg,
        showLogoutMsg = _this$state3.showLogoutMsg,
        showReviewButtonOnCompletion = _this$state3.showReviewButtonOnCompletion,
        type = _this$state3.type;
      var _this$props2 = this.props,
        allowLanguageChange = _this$props2.allowLanguageChange,
        assignmentOptions = _this$props2.assignmentOptions,
        disableLayout = _this$props2.disableLayout,
        errorLayout = _this$props2.errorLayout,
        flowProps = _this$props2.flowProps,
        isFinalTestMode = _this$props2.isFinalTestMode,
        isPreviewMode = _this$props2.isPreviewMode,
        languagePicker = _this$props2.languagePicker,
        onComplete = _this$props2.onComplete,
        onModuleComplete = _this$props2.onModuleComplete,
        onFlowComplete = _this$props2.onFlowComplete,
        requiredAssignmentOptions = _this$props2.requiredAssignmentOptions,
        surveylist = _this$props2.surveylist,
        surveylistRandomizer = _this$props2.surveylistRandomizer,
        shouldSaveFlowList = _this$props2.shouldSaveFlowList,
        shouldSaveLanguage = _this$props2.shouldSaveLanguage;
      var pawnId = this.props.pawnId || ((_this$state$pawn = this.state.pawn) === null || _this$state$pawn === void 0 ? void 0 : _this$state$pawn.id);
      var pawnHash = this.props.pawnHash || ((_this$state$pawn2 = this.state.pawn) === null || _this$state$pawn2 === void 0 ? void 0 : _this$state$pawn2.random_hash);
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      if (show404) {
        if (errorLayout) {
          var ErrorLayout = errorLayout;
          return /*#__PURE__*/_react["default"].createElement(ErrorLayout, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, {
            force404: type !== 'group'
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, {
          force404: type !== 'group'
        });
      }
      if (showLogoutMsg && settings.autoLogout) {
        var anonymousLogoutMsg = /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.anonAutoLogoutMessage
        });
        var knownLogoutMsg = /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.knownAutoLogoutMessage
        });
        return settings.respondentConfig === 'anonymous' ? this.getPlayerLayout(anonymousLogoutMsg) : this.getPlayerLayout(knownLogoutMsg);
      }
      if (showCompletedMsg) {
        var completedMsg = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.completedMessage || 'You have already completed'
        }), settings.individualPasscode && /*#__PURE__*/_react["default"].createElement(_CompletionButton["default"], {
          label: settings.passcodeCompletionButtonText
        }));
        return disableLayout ? completedMsg : this.getPlayerLayout(completedMsg);
      }
      if (showCompletionMsg) {
        var completionMsg = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            maxWidth: '85vw'
          }
        }, /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: completionMessage || settings.completionMessage || 'You are all done'
        }), showReviewButtonOnCompletion && settings.allowRetake && !settings.isRepeated && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary pull-right",
          onClick: function onClick() {
            return window.location.replace(window.location.href);
          },
          style: {
            marginTop: '1rem'
          }
        }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], null), " Review"), settings.individualPasscode && /*#__PURE__*/_react["default"].createElement(_CompletionButton["default"], {
          label: settings.passcodeCompletionButtonText
        }));
        return disableLayout ? completionMsg : this.getPlayerLayout(completionMsg);
      }
      var localOnComplete = this.setLocalOnComplete();
      var modifiedOnComplete = onComplete ? /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(ocLanguage, ocFlowList, ocPawnId) {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return onComplete(ocLanguage, ocFlowList);
                case 2:
                  localOnComplete(ocLanguage, ocFlowList, ocPawnId);
                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));
        return function (_x11, _x12, _x13) {
          return _ref9.apply(this, arguments);
        };
      }() : localOnComplete;
      var updatedFlowProps = Object.assign({}, flowProps, {
        pawnHash: pawnHash,
        pawnId: pawnId,
        responseSet: deploymentId
      });
      var options = assignmentOptions.length ? assignmentOptions : settings.options;

      // Get mediator
      var mediator = this.props.mediator;
      var mediatorProps = this.props.mediatorProps;
      if (!mediator && assignmentData.navigation) {
        var currentNavigation = _navigations["default"].find(function (item) {
          return item.handle === assignmentData.navigation;
        });
        if (currentNavigation) {
          mediator = currentNavigation.mediatorComponent;
          mediatorProps = !Array.isArray(assignmentData.navigationSettings) ? Object.assign({}, assignmentData.navigationSettings, mediatorProps) : {};
        }
      }

      // For backwards compatibility
      // TODO: remove enablePrintMode from props
      if (this.props.enablePrintMode) {
        mediatorProps.enablePrintMode = this.props.enablePrintMode;
      }
      var assignment = /*#__PURE__*/_react["default"].createElement(_Assignment["default"], {
        allSurveyProgress: allSurveyProgress,
        deploymentId: deploymentId,
        deploymentSettings: settings,
        parentDeploymentId: parentDeploymentId,
        relatedDeploymentId: relatedDeploymentId,
        handle: assignmentData.handle,
        label: assignmentData.label,
        surveylists: assignmentData.surveylists,
        languages: assignmentData.languages,
        surveylistRandomizer: surveylistRandomizer,
        surveylist: surveylist,
        flowList: this.props.flowList || this.state.flowList || null,
        shouldSaveFlowList: shouldSaveFlowList,
        mediator: mediator,
        mediatorProps: mediatorProps,
        language: this.props.language || this.state.language,
        languagePicker: languagePicker,
        allowLanguageChange: allowLanguageChange,
        shouldSaveLanguage: shouldSaveLanguage,
        onComplete: modifiedOnComplete,
        onModuleComplete: onModuleComplete,
        onFlowComplete: onFlowComplete,
        onAlreadyComplete: this.onAlreadyComplete,
        flowProgress: this.props.flowProgress || this.state.flowProgress,
        flowProps: updatedFlowProps,
        options: options,
        requiredOptions: requiredAssignmentOptions,
        allowRetake: settings.allowRetake,
        isFinalTestMode: isFinalTestMode,
        isPreviewMode: isPreviewMode,
        showRecaptcha: settings.recaptcha,
        individualPasscode: settings.individualPasscode,
        passcodeAssistant: settings.passcodeAssistant,
        passcodeLabel: settings.individualPasscode,
        passcodeBackground: settings.passcodeBackground,
        passcodeBackgroundColor: settings.passcodeBackgroundColor,
        passcodeBackgroundUpload: settings.passcodeBackgroundUpload,
        passcodeCompletionButtonText: settings.passcodeCompletionButtonText,
        autoLogout: settings.autoLogout,
        anonAutoLogoutMessage: settings.anonAutoLogoutMessage,
        knownAutoLogoutMessage: settings.knownAutoLogoutMessage,
        autoLogoutTime: settings.autoLogoutTime,
        assignmentProgressChecked: true
      });
      if (disableLayout) {
        return assignment;
      }
      return this.getPlayerLayout(assignment);
    }
  }]);
  return DeploymentPlayer;
}(_react["default"].Component);
exports["default"] = DeploymentPlayer;
_defineProperty(DeploymentPlayer, "propTypes", {
  /** This is one way we can look up the deployment if no deploymentId provided */
  deploymentHandle: _propTypes["default"].string,
  /** This is one way we can look it up if no */
  deploymentId: _propTypes["default"].number,
  /** Should we render the assignment without any wrapping? */
  disableLayout: _propTypes["default"].bool,
  /** The layout to use for the 404 page */
  errorLayout: _propTypes["default"].func,
  /** The id of the pawn against which we will record progress */
  pawnId: _propTypes["default"].number,
  /** The hash of the pawn against which we will record progress */
  pawnHash: _propTypes["default"].string,
  /** The surveylist you want to use */
  surveylist: _propTypes["default"].string,
  /** An alternate function to replace default surveylistRandomizer */
  surveylistRandomizer: _propTypes["default"].func,
  /** Should we save the selected flowList to `$pawn->data->flowList`? (default false) */
  shouldSaveFlowList: _propTypes["default"].bool,
  /** The flowList you want to use */
  flowList: _propTypes["default"].string,
  /** An alternate React Component to replace default Mediator */
  mediator: _propTypes["default"].func,
  /** Custom props for mediator */
  mediatorProps: _propTypes["default"].object,
  /** The language you want to use */
  language: _propTypes["default"].string,
  /** An alternate function to replace default LanguagePicker */
  languagePicker: _propTypes["default"].object,
  /** Should we allow changing of language? (default true) */
  allowLanguageChange: _propTypes["default"].bool,
  /** Should we save the selected language to `$pawn->data->language`? (default false) */
  shouldSaveLanguage: _propTypes["default"].bool,
  /** A function to call once assignment is complete (including non-required flows) */
  onComplete: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /** A function to call each time a module is completed (if assignment is using withModules navigation) */
  onModuleComplete: _propTypes["default"].func,
  /** A function to call each time a flow is completed */
  onFlowComplete: _propTypes["default"].func,
  /** A function to call once the user logged out because of inactivity */
  onLogout: _propTypes["default"].func,
  /** An array of flow progress, i.e., from GraphQL. If provided, is used instead of querying for it. */
  flowProgress: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow will be included. */
  assignmentOptions: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow `isRequired` setting will be overridden to true.
   * For flows that are not included, `isRequired` will be overridden to false. */
  requiredAssignmentOptions: _propTypes["default"].array,
  /** Override deployment setting allowRetake */
  allowRetake: _propTypes["default"].bool,
  /** Should we invoke the player in Final Test mode? */
  isFinalTestMode: _propTypes["default"].bool,
  /** Should we skip saving everything and not run any pre/postFlowRoutes? */
  isPreviewMode: _propTypes["default"].bool,
  /** An object containing props that each flow should have */
  flowProps: _propTypes["default"].object,
  /** An object with preloaded state values. Used to reduce the query numbers. */
  preloadedState: _propTypes["default"].object,
  /**
   * !DEPRECATED
   * Flag to set enablePrintMode in mediatorProps
   * TODO: Remove enablePrintMode from props
   */
  enablePrintMode: _propTypes["default"].bool
});
_defineProperty(DeploymentPlayer, "defaultProps", {
  disableLayout: false,
  errorLayout: null,
  surveylist: null,
  surveylistRandomizer: null,
  shouldSaveFlowList: false,
  mediator: null,
  mediatorProps: {},
  languagePicker: null,
  allowLanguageChange: true,
  shouldSaveLanguage: false,
  onComplete: null,
  onModuleComplete: null,
  onFlowComplete: null,
  flowProgress: null,
  assignmentOptions: [],
  requiredAssignmentOptions: null,
  allowRetake: null,
  isFinalTestMode: false,
  isPreviewMode: false,
  flowProps: {}
});